// extracted by css-extract-rspack-plugin
var _1 = "accent__wNfrT";
var _2 = "header__Gzsg0";
var _3 = "header--closer__ARkHF";
var _4 = "header--contact-info__zlVjV";
var _5 = "header--sidebar-ified__X8EHJ";
var _6 = "header--with-description__XTDz_";
var _7 = "subsection__Ua9X5";
var _8 = "subsection--contact-info__wSUgN";
var _9 = "subsection--stretch__a4ojn";
var _a = "subsection__description__wy75S";
var _b = "title__GDDOF";
export { _1 as "accent", _2 as "header", _3 as "header--closer", _4 as "header--contact-info", _5 as "header--sidebar-ified", _6 as "header--with-description", _7 as "subsection", _8 as "subsection--contact-info", _9 as "subsection--stretch", _a as "subsection__description", _b as "title" }
export default { "accent": _1, "header": _2, "header--closer": _3, "header--contact-info": _4, "header--sidebar-ified": _5, "header--with-description": _6, "subsection": _7, "subsection--contact-info": _8, "subsection--stretch": _9, "subsection__description": _a, "title": _b }
